import { CardInfoDto } from "./card-info.dto";

export class CardInfoTranslationDto {
   /*
   *
   */
    constructor(
      public id?:  number,
      public locale?: string,
      public title?: string,
      public cardInfo?: CardInfoDto  
    ){}
    
}